import { render, staticRenderFns } from "./ComboMunicipioUf.vue?vue&type=template&id=273fc9af&scoped=true"
import script from "./ComboMunicipioUf.vue?vue&type=script&lang=js"
export * from "./ComboMunicipioUf.vue?vue&type=script&lang=js"
import style0 from "./ComboMunicipioUf.vue?vue&type=style&index=0&id=273fc9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273fc9af",
  null
  
)

export default component.exports